export enum SalesConciergeContactType {
    EXISTING_CONTACT_INFO = 'Hinterlegte Kontaktdaten',
    CUSTOM_CONTACT_INFO = 'Andere Kontaktdaten'

}

